import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { ETipoTransaccion } from '@core/enums/tipoTransaccion.enum';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { IOptionsSelect } from '@core/interfaces/options.select.interface';
import { ICrearTipoPagoReq } from '@core/interfaces/request-response/tipoPago.dto.interface';
import { TipoPagoApiService } from '@core/services/api/tipo-pago-api.service';
import { ToastService } from '@shared/services/toast.service';
import { buildDiff } from '@shared/utils/functions.utils';
import { UiSelect } from '@shared/components/ui';

@Component({
  selector: 'app-editar-tipo-pago',
  imports: [FormField, UiSelect],
  templateUrl: './editar-tipo-pago.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './editar-tipo-pago.css',
})
export class EditarTipoPago implements OnInit {
  ngOnInit(): void {
    this.tipo_transaccion = Object.values(ETipoTransaccion);
    this.opcionesTipoTransaccion.set(
      this.tipo_transaccion.map((tipo) => ({
        label: tipo,
        value: tipo,
      })),
    );
    this.formTipoPago().value.set({
      nombre: this.tipoPago().nombre || '',
      tipo_transaccion: this.tipoPago().tipo_transaccion || ETipoTransaccion.EFECTIVO,
    });
  }
  // servicios
  private toastService = inject(ToastService);
  private tipoPagoApiService = inject(TipoPagoApiService);
  // datos
  tipoPago = input.required<ITipoPagoData>();
  tipo_transaccion: ETipoTransaccion[] = [];
  opcionesTipoTransaccion = signal<IOptionsSelect<ETipoTransaccion>[]>([]);
  formTipoPago = form(
    signal({
      nombre: '',
      tipo_transaccion: ETipoTransaccion.EFECTIVO,
    }),
  );
  cerrar = output<ITipoPagoData | undefined>();

  // métodos
  cancelar() {
    this.cerrar.emit(undefined);
  }
  guardar($event: Event) {
    $event.preventDefault();
    const formValue = this.formTipoPago().controlValue();
    const current: Partial<ICrearTipoPagoReq> = {
      nombre: formValue.nombre,
      tipo_transaccion: formValue.tipo_transaccion,
    };
    const original: ICrearTipoPagoReq = {
      nombre: this.tipoPago().nombre,
      tipo_transaccion: this.tipoPago().tipo_transaccion,
    };
    const dataToSave: Partial<ICrearTipoPagoReq> = buildDiff(original, current);
    if (!Object.keys(dataToSave).length) {
      this.cerrar.emit(undefined);
      return;
    }
    this.tipoPagoApiService.editar(this.tipoPago().id, dataToSave).subscribe({
      next: (tipoPagoEditado) => {
        this.toastService.show(
          'top-right',
          'success',
          'Tipo Pago',
          'Tipo de pago editado correctamente.',
        );
        this.cerrar.emit(tipoPagoEditado);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Tipo Pago',
          err.error?.message || 'Error al editar el tipo de pago.',
        );
      },
    });
  }
}
